import { createContext } from "react";

export const InventariosDetContext = createContext()
export const InventariosDetFormContext = createContext()
export const InventariosDetReportContext = createContext()